import { LGraphNode, LiteGraph } from "litegraph.js";
import { addDrivableSlider, finalizeDrivableSliders, syncDrivableSliders } from "../utils/addDrivableSlider.js";

/**
 * StaggerNode
 * -----------
 * Takes a single numeric input and outputs multiple delayed copies.
 * Each output is the input value from N frames ago — a delay line.
 */
export class StaggerNode extends LGraphNode {
  constructor() {
    super();
    this.title = "Stagger";

    this.properties = {
      outputs: 4,
      delay: 6,
    };

    this._buffer = [];
    this._bufferSize = 0;

    this.addInput("Value", "number");

    addDrivableSlider(this, "Delay", "delay", 6, 1, 60, 1);

    finalizeDrivableSliders(this, 1);

    // Create initial outputs
    this._rebuildOutputs();

    this.addWidget("combo", "Outputs", "4", (val) => {
      this.properties.outputs = parseInt(val);
      this._rebuildOutputs();
    }, { values: ["2", "3", "4", "5", "6", "8"] });

    this.size = [200, 100];
    this.mode = LiteGraph.ALWAYS;
    this.color = "#2a2a2a";
    this.bgcolor = "#333333";
  }

  _rebuildOutputs() {
    // Remove old outputs
    while (this.outputs && this.outputs.length) {
      this.removeOutput(0);
    }
    for (let i = 0; i < this.properties.outputs; i++) {
      this.addOutput(`Out ${i + 1}`, "number");
    }
    this._buffer = [];
  }

  onExecute() {
    syncDrivableSliders(this);

    const input = this.getInputData(0);
    const val = input != null ? input : 0;
    const delay = Math.max(1, Math.round(this.properties.delay));
    const totalNeeded = delay * this.properties.outputs;

    // Push new value
    this._buffer.push(val);

    // Trim buffer
    if (this._buffer.length > totalNeeded + 1) {
      this._buffer.splice(0, this._buffer.length - totalNeeded - 1);
    }

    // Output staggered values
    for (let i = 0; i < this.properties.outputs; i++) {
      const idx = this._buffer.length - 1 - (i * delay);
      const out = idx >= 0 ? this._buffer[idx] : val;
      this.setOutputData(i, out);
    }
  }
}

LiteGraph.registerNodeType("generators/Stagger", StaggerNode);
